import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-504f96e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/error_img.png",
  alt: "",
  class: "image-preview image-preview-name"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/error_img.png",
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/error_img.png",
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "text-name" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 1,
  class: "status-span"
}

import { codeName } from '@/components/BlackGoods/data'
import { t } from '@/plugins/i18n'
import { ref, watch } from 'vue'
import AppLink from '@/components/common/AppLink.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  image: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    default: ''
  },
  url: {
    type: String,
    default: ''
  },
  showStatus: {
    type: Boolean,
    default: false
  },
  errorCode: {
    type: Number,
    default: 0
  },
  // 滚动元素
  lazyEle: {
    type: [String, HTMLElement, Element],
    default: ''
  },
  product: {
    type: Object,
    default: () => {
      return {}
    }
  }
},
  setup(__props) {

const props = __props

const imageUrl = ref('')
let isEdit = false
watch(() => props.image, (newValue: any) => {
  if (newValue.includes('alicdn')) {
    console.log(newValue)
    imageUrl.value = props.image + '_50x50.jpg_.webp'
    isEdit = true
  } else if (newValue.includes('chinagoods')) {
    console.log(newValue)
    imageUrl.value = props.image + '?imageMogr2/thumbnail200x200/color/#FFF'
    isEdit = true
  } else {
    imageUrl.value = props.image
  }
}, {
  immediate: true
})
const popImage = ref()
const showImage = () => {
  popImage.value = props.image
}
const load = (e: any) => {
  console.log(e.target.naturalWidth)
}
const error = (e: any) => {
  if (isEdit) {
    imageUrl.value = props.image
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ disabled: __props.showStatus }, 'flex-center']),
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_el_popover, {
      placement: "top-start",
      width: "168",
      "popper-class": "shopping-preview",
      trigger: "hover",
      "hide-after": 30,
      onShow: showImage
    }, {
      reference: _withCtx(() => [
        (__props.url)
          ? (_openBlock(), _createBlock(AppLink, {
              key: 0,
              to: __props.url,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  "referrer-policy": "no-referrer",
                  class: "image name",
                  src: imageUrl.value,
                  alt: __props.name,
                  lazy: !!__props.lazyEle,
                  "scroll-container": __props.lazyEle,
                  onLoad: load,
                  onError: error
                }, {
                  error: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["src", "alt", "lazy", "scroll-container"])
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_image, {
          "referrer-policy": "no-referrer",
          class: "image name",
          src: imageUrl.value,
          alt: __props.name,
          lazy: !!__props.lazyEle,
          "scroll-container": __props.lazyEle,
          onLoad: load,
          onError: error
        }, {
          error: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["src", "alt", "lazy", "scroll-container"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_image, {
            "referrer-policy": "no-referrer",
            class: "image-preview image-preview-name",
            src: popImage.value,
            alt: __props.name
          }, {
            error: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["src", "alt"])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      (__props.name)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "name",
            style: _normalizeStyle({ '-webkit-line-clamp': __props.showStatus ? 1 : 2 })
          }, [
            (__props.url)
              ? (_openBlock(), _createBlock(AppLink, {
                  key: 0,
                  to: __props.url,
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(__props.name), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.name), 1))
          ], 4))
        : _createCommentVNode("", true),
      (__props.showStatus)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.errorCode === 99 ? _unref(codeName)[__props.product.platformItemSku.blackReasonCode]?.normal  :['', _unref(t)('已失效'), _unref(t)('已下架'), _unref(t)('库存不足'), _unref(t)('商品不存在'),
        _unref(t)('未关联')][__props.errorCode]), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})